class StickyNavController {
	static SELECTOR_STICKYNAV = '.navigation__stickynav'
	static SELECTOR_NAV_MENU = '.navigation__stickynav .navigation__menu'
	static CLASS_NAV_MENU_STICKY = 'navigation__menu--sticky'
	static CLASS_STICKYNAV_LOCKED = 'navigation__stickynav--locked'
	static CLASS_NAV_LOCKED = 'navigation__locked'
	static BREAKPOINT_MIN_WIDTH = 768

	constructor() {
		document.addEventListener( 'DOMContentLoaded', () => {
			this.init()
		} )
	}

	init() {
		const stickyNav = document.querySelector( StickyNavController.SELECTOR_STICKYNAV )
		if ( !stickyNav ) {
			return
		}

		if ( window.innerWidth <= StickyNavController.BREAKPOINT_MIN_WIDTH ) {
			return
		}

		const navMenu = document.querySelector( StickyNavController.SELECTOR_NAV_MENU )
		if ( !navMenu ) {
			return
		}

		const stickyInitial = navMenu.offsetTop

		document.addEventListener( 'scroll', () => {
			if ( document.documentElement.scrollTop >= stickyInitial || document.body.scrollTop >= stickyInitial ) {
				navMenu.classList.add( StickyNavController.CLASS_NAV_MENU_STICKY )
				stickyNav.classList.add( StickyNavController.CLASS_STICKYNAV_LOCKED )
				document.body.classList.add( StickyNavController.CLASS_NAV_LOCKED )
			} else {
				navMenu.classList.remove( StickyNavController.CLASS_NAV_MENU_STICKY )
				stickyNav.classList.remove( StickyNavController.CLASS_STICKYNAV_LOCKED )
				document.body.classList.remove( StickyNavController.CLASS_NAV_LOCKED )
			}
		} )
	}
}

new StickyNavController()
